/**
 * boardRenderConfig.ts — centralized board-artwork rendering parameters.
 *
 * These are pure visual-calibration values for how the board table image is
 * sized relative to the gameplay tile grid. Swapping board artwork (see
 * ASSETS.board.TABLE_CLASSIC in config/assets.ts) should only ever require
 * adjusting a value here — never gameplay/engine coordinates.
 */
export const BOARD_RENDER = {
  /**
   * Felt headroom for the gameplay tile grid: the tile unit is derived as
   * floor(drawnTable / (19 * this factor)), reserving enough of the table
   * artwork around the grid that tiles sit inside the leather/felt region
   * without touching the wood frame. The drawn table image itself is sized by
   * drawnTableSize() in utils/sceneLayout.ts (fills the canvas square) —
   * shared by Board.ts and GameScene.ts so the two never drift apart.
   */
  TABLE_VISUAL_SCALE: 1.15,
} as const;
